import { render } from "./ListasDestinatarios.vue?vue&type=template&id=ccd0a654&scoped=true"
import script from "./ListasDestinatarios.vue?vue&type=script&lang=js"
export * from "./ListasDestinatarios.vue?vue&type=script&lang=js"

import "./ListasDestinatarios.vue?vue&type=style&index=0&id=ccd0a654&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccd0a654"]])

export default __exports__